import {
  pageInfo,
  submitImport,
  taskPkgEditInit,
  taskPkgEdit,
  taskPkgDetail,
  homePush,
  homeRanking,
  deleteData,
  closeData,
  exportData,
} from './../api';
import {taskPkgTypeSelect, taskPkgStatusSelect, taskPkgAreaCitySelect, taskPkgAreaSelect, regionSelect, uploadImage} from '../../../../api'
const taskList = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    deleteResp: null,
    taskUpdInitObj: null,
    taskPkgTypeObj: null,
    taskPkgStatusObj: null,
    taskPkgAreaObj: null,
    taskPkgRegionObj: null,
    taskImgUploadObj: null,
    taskPkgEditObj: null,
    taskPkgDetailObj: null,
    homePush: null,
    homeRankIng: null,
    closeResp: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({
        ...item,
        btns: [item.taskPkgStatusNo == 'TK001' || item.taskPkgStatusNo == 'TK002' ? true : false, item.taskPkgStatusNo != 'TK001' ? true : false],
        homeRankingFlag_disabled: item.taskPkgStatusNo == 'TK003' || item.taskPkgStatusNo == 'TK009' ? true : false,
        homePushFlag_disabled: item.taskPkgStatusNo == 'TK003' || item.taskPkgStatusNo == 'TK009' || item.taskPkgMustFlag == 'Y' ? true : false,
      }));
    },
    //新增-提交
    SUBMIT_IMPORT_DATA(state, data){
      state.submitImportObj = data;
    },
    /**
     * 图片上传
     */
    TASK_IMG_UPLOAD(state, data) {
      state.taskImgUploadObj = data;
    },
    /**
     * 初始化
     */
    TASK_PKG_EDIT_INIT(state, data) {
      state.taskUpdInitObj = data;
    },
    /**
     * 修改提交
     */
    TASK_PKG_EDIT(state, data) {
      state.taskPkgEditObj = data;
    },
    /**
     * 详情
     */
    TASK_PKG_DETAIL(state, data) {
      state.taskPkgDetailObj = data;
    },
    /**
     * 删除
     */
    DELETE_DATA(state, data){
      state.deleteResp = data;
    },

    /**
     * 关闭
     */
    CLOSE_DATA(state, data){
      state.closeResp = data;
    },
    /**
     * 首页推送
     * @param state
     * @param data
     * @constructor
     */
    HOME_PUSH(state, data){
      state.homePush = data;
    },
    /**
     * 首页排行
     * @param state
     * @param data
     * @constructor
     */
    HOME_RANKING(state, data){
      state.homeRankIng = data;
    },
    /**
     * 导出
     * @param state
     * @param data
     * @constructor
     */
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    /**
     * 任务类型
     */
    TASK_PKG_TYPE(state, data){
      state.taskPkgTypeObj = data.obj;
    },
    /**
     * 任务状态
     * @param state
     * @param data
     * @constructor
     */
    TASK_PKG_STATUS(state, data){
      state.taskPkgStatusObj = data.obj;
    },
    /**
     * 适用区域
     * @param state
     * @param data
     * @constructor
     */
    TASK_PKG_AREA(state, data){
      state.taskPkgAreaObj = data.obj;
    },
    /**
     * 大区列表
     * @param state
     * @param data
     * @constructor
     */
    TASK_PKG_REGION(state, data){
      state.taskPkgRegionObj = data.obj;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    /**
     * 新增-提交
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async submitImport({ commit }, obj) {
      let resp = await submitImport(obj);
      commit('SUBMIT_IMPORT_DATA', resp);
    },
    /**
     * 图片上传
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async taskImgUpload({ commit }, obj) {
      let resp = await uploadImage(obj);
      commit('TASK_IMG_UPLOAD', resp);
    },
    /**
     * 修改提交
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async taskPkgEdit({ commit }, obj) {
      let resp = await taskPkgEdit(obj);
      commit('TASK_PKG_EDIT', resp);
    },
    /**
     * 初始化
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async taskPkgEditInit({ commit }, obj) {
      let resp = await taskPkgEditInit(obj);
      commit('TASK_PKG_EDIT_INIT', resp);
    },
    /**
     * 查看详情
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async taskPkgDetail({ commit }, obj) {
      let resp = await taskPkgDetail(obj);
      commit('TASK_PKG_DETAIL', resp);
    },
    /**
     * 删除
     */
    async deleteData({commit}, obj) {
      let resp = await deleteData(obj);
      commit('DELETE_DATA', resp);
    },
    /**
     * 关闭
     */
    async closeData({commit}, obj) {
      let resp = await closeData(obj);
      commit('CLOSE_DATA', resp);
    },
    /**
     * 首页推送
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async homePush({commit}, obj) {
      let resp = await homePush(obj);
      commit('HOME_PUSH', resp);
    },
    /**
     * 首页排行
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async homeRanking({commit}, obj) {
      let resp = await homeRanking(obj);
      commit('HOME_RANKING', resp);
    },
    //导出数据
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    /**
     * 任务类型
     */
    async taskPkgTypeSelect({commit}, obj) {
      let resp = await taskPkgTypeSelect(obj);
      commit('TASK_PKG_TYPE', resp);
    },
    /**
     * 任务状态
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async taskPkgStatusSelect({commit}, obj) {
      let resp = await taskPkgStatusSelect(obj);
      commit('TASK_PKG_STATUS', resp);
    },
    /**
     * 适用区域
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async taskPkgAreaCitySelect({commit}, obj) {
      let resp = await taskPkgAreaCitySelect(obj);
      commit('TASK_PKG_AREA', resp);
    },
    /**
     * 大区列表下拉框
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async taskPkgRegionSelect({commit}, obj) {
      let resp = await regionSelect(obj);
      commit('TASK_PKG_REGION', resp);
    },
    /**
     * 适用区域（按大区筛选）
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async taskPkgAreaSelectByRegion({commit}, obj) {
      let resp = await taskPkgAreaSelect(obj);
      commit('TASK_PKG_AREA', resp);
    },
  }
}
export default taskList



// WEBPACK FOOTER //
// ./src/page/taskManagement/taskList/store/taskList.store.js